import { WhatsNewWelcome, type WhatsNewSlide } from '@odo/shared-ui';
import type { VideoRelease } from './types';
import { VideoPartSlide } from './VideoPartSlide';
import { videoReleaseSlideSpecs, type VideoReleaseSlideSpec } from './videoReleaseSlideSpecs';

// Keyed so each slide remounts and replays its staged reveal instead of reusing the last one.
function slideContent(spec: VideoReleaseSlideSpec, release: VideoRelease) {
    if (spec.kind === 'welcome') {
        return (
            <WhatsNewWelcome
                key={spec.id}
                headline={release.welcome.headline}
                subtitle={release.welcome.subtitle}
            />
        );
    }
    return <VideoPartSlide key={spec.id} part={spec.part} />;
}

export function videoReleaseSlides(release: VideoRelease): WhatsNewSlide[] {
    return videoReleaseSlideSpecs(release).map((spec) => ({
        id: spec.id,
        label: spec.label,
        content: slideContent(spec, release)
    }));
}
